import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Cross-route hash navigation: Link to="/#sample" from /pricing changes the
// route, but #sample doesn't exist in the DOM until the new route's
// components mount. The browser's native hash handling fires too early,
// finds nothing, and scroll stays put. Two rAFs after route change is
// enough for layout (incl. images) to settle, then we scroll.
//
// Mirrors the after-mount hash-restore effect from the original index.html.
export default function HashScroller() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash || hash.length < 2) return;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const el = document.getElementById(hash.slice(1));
        if (!el) return;
        const top = el.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({ top, behavior: 'auto' });
      });
    });
  }, [pathname, hash]);
  return null;
}
